const URLS = {
    Trading: '/',
    Wallet: '/wallet',
    AddCurrency: '/add_currency',
    Analytics: '/analytics',
    Traders: '/traders',
    Trader: '/trader',
    Post: '/post',
    Messages: '/messages',
    MarketsList: '/markets_list',
    Account: '/account',
    SIGNIN: '/signin',
    SIGNUP: '/signup',
    RESETPASSWORD: '/reset_password'
};

export default URLS


// WEBPACK FOOTER //
// ./src/constants/urls.js